import moment from 'moment';
import GeckoStore from 'services/gecko-store';

class GeckoDate {
  constructor(date = new Date(), format, options = { enableUTC: false }) {
    const { enableUTC } = options;
    if (date instanceof moment) {
      this._moment = enableUTC ? date.utc() : date;
      return this;
    }
    if (format) {
      this._moment = enableUTC
        ? moment(date, format, true).utc()
        : moment(date, format, true);
      return this;
    }
    this._moment = enableUTC
      ? moment(new Date(date), format, true).utc()
      : moment(new Date(date), format, true);
    return this;
  }

  static FORMATS = {
    'DD/MM/YYYY': {
      DEFAULT: 'DD/MM/YYYY',
      FULL: 'Do MMMM YYYY [at] HH:mm',
      LONG: 'Do MMM YYYY',
      LONG_TIME: 'Do MMM YYYY [at] HH:mm',
      SHORT: 'DD/MM/YYYY',
      SHORT_TIME: 'DD/MM/YYYY HH:mm',
      HIPSTER_SHORT_TIME: 'DD/MM/YY @ hh.mma',
    },
    'MM/DD/YYYY': {
      DEFAULT: 'MM/DD/YYYY',
      FULL: 'MMMM Do YYYY [at] HH:mm',
      LONG: 'MMM Do YYYY',
      LONG_TIME: 'MMM Do YYYY [at] HH:mm',
      SHORT: 'MM/DD/YYYY',
      SHORT_TIME: 'MM/DD/YYYY HH:mm',
      HIPSTER_SHORT_TIME: 'MM/DD/YY @ hh.mma',
    },
  };

  get moment() {
    return this._moment;
  }

  get FORMATS() {
    const format = GeckoStore.redux.get('appState.dateFormat') || 'DD/MM/YYYY';
    return GeckoDate.FORMATS[format];
  }

  get DEFAULT() {
    return this.format(this.FORMATS.DEFAULT);
  }
  get FULL() {
    return this.format(this.FORMATS.FULL);
  }
  get LONG() {
    return this.format(this.FORMATS.LONG);
  }
  get LONG_TIME() {
    return this.format(this.FORMATS.LONG_TIME);
  }
  get SHORT() {
    return this.format(this.FORMATS.SHORT);
  }
  get SHORT_TIME() {
    return this.format(this.FORMATS.SHORT_TIME);
  }

  format(_format) {
    const format =
      _format || GeckoStore.redux.get('appState.dateFormat') || 'DD/MM/YYYY';
    return this._moment.format(format);
  }

  toString() {
    return this.format(this.FORMATS.DEFUALT);
  }

  startOf(TimeMutates) {
    return this._moment.startOf(TimeMutates);
  }

  isValid() {
    return this._moment.isValid();
  }
}

export default GeckoDate;
